module.exports = __webpack_public_path__ + "img/IMG_1645_Foamcore.f0795b21.jpg";